import { render } from "./Master.vue?vue&type=template&id=50273c94&scoped=true"
import script from "./Master.vue?vue&type=script&lang=js"
export * from "./Master.vue?vue&type=script&lang=js"

import "./Master.vue?vue&type=style&index=0&id=50273c94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50273c94"]])

export default __exports__